import React, {Component} from 'react';

class SettingsHelpMenu extends Component {
    constructor(props) {
        super(props)
        
    }
    
    render() {
        const { onClose } = this.props

        return (
            <div className="overlay-settings-help" onClick={e => {onClose(e)}}>
                
                <div className=" row setting-help" style={{color: '#000', padding: 20}}>
                    <div className="col-sm-9"><h1 style={{fontWeight: 700, textAlign: 'right'}}>Help</h1></div>
                    <div className="col-sm-3">
                        <button className="float-right" style={{width: '30px', height: '30px', borderRadius: '50%', background: "#fff", borderColor: "#333"}} onClick={e => {
                            this.refs.video && this.refs.video.pause();
                            onClose(e);
                            }}>X
                        </button>
                    </div>
                    <div className="col-sm-12"><p style={{fontSize: 15, textAlign: 'center'}}>For any issues please email <strong>fvhelp@joshcogroup.com</strong></p></div>
                    
                </div>
            </div>
        );
    }
}

export default SettingsHelpMenu